import { render } from "./ItemInTransferRequest.vue?vue&type=template&id=77a8a730&scoped=true"
import script from "./ItemInTransferRequest.vue?vue&type=script&lang=js"
export * from "./ItemInTransferRequest.vue?vue&type=script&lang=js"

import "./ItemInTransferRequest.vue?vue&type=style&index=0&id=77a8a730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a8a730"]])

export default __exports__